var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCircleRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_29842)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5 0.152344C4.53724 0.152344 0.5 4.18958 0.5 9.15234C0.5 14.1151 4.53724 18.1523 9.5 18.1523C14.4628 18.1523 18.5 14.1151 18.5 9.15234C18.5 4.18958 14.4628 0.152344 9.5 0.152344ZM12.2803 9.68261L8.53025 13.4326C8.384 13.5788 8.19201 13.6523 7.99999 13.6523C7.808 13.6523 7.61598 13.5788 7.46973 13.4326C7.17649 13.1393 7.17649 12.6653 7.46973 12.3721L10.6895 9.15234L7.46976 5.93259C7.17652 5.63936 7.17652 5.16534 7.46976 4.87211C7.763 4.57887 8.23701 4.57887 8.53025 4.87211L12.2803 8.62212C12.5735 8.91536 12.5735 9.38933 12.2803 9.68261Z",
    fill: "#046C9C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_29842"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.5 0.152344)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCircleRight);
export default __webpack_public_path__ + "static/media/icon-circle-right.ac9b14eea58ef94314e5c41053f87e11.svg";
export { ForwardRef as ReactComponent };